import { render } from "./dashboardPage_test.vue?vue&type=template&id=6816674b&scoped=true"
import script from "./dashboardPage_test.vue?vue&type=script&lang=js"
export * from "./dashboardPage_test.vue?vue&type=script&lang=js"

import "./dashboardPage_test.vue?vue&type=style&index=0&id=6816674b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6816674b"]])

export default __exports__